module.exports = "<div class=\"beta-banner\" ng-if=\"showBetaBanner\">\n  <div class=\"text\">\n    👋 Hey, you've been selected to be a beta user for the new TablelistPro. <a href=\"https://app.tablelistpro.com\" target=\"_blank\">Click here</a> to try it out.\n  </div>\n  <a href=\"#\" class=\"close-btn\" ng-click=\"hideBetaBanner($event)\">\n    <i class=\"icon ion-close-round\"></i>\n  </a>\n</div>\n<ui-view></ui-view>\n";


//////////////////
// WEBPACK FOOTER
// ./src/components/app/app.html
// module id = 1141
// module chunks = 0